import React from 'react';
import { Container, Accordion } from 'react-bootstrap';

const faqs = [
  {
    question: 'What is the warranty on your products?',
    answer: 'All our products come with a 1-year manufacturer warranty.'
  },
  {
    question: 'How can I track my order?',
    answer: 'Once your order is shipped, you will receive an email with the tracking information.'
  },
  {
    question: 'What is your return policy?',
    answer: 'We offer a 30-day return policy on all our products. Please visit our returns page for more information.'
  },
  {
    question: 'Do you ship internationally?',
    answer: 'Yes, we ship to most countries around the world. Shipping costs and delivery times may vary.'
  }
];

const FAQ = () => {
  return (
    <Container className="py-5">
      <h1 className="text-center mb-5">Frequently Asked Questions</h1>
      <Accordion defaultActiveKey="0">
        {faqs.map((faq, index) => (
          <Accordion.Item eventKey={index.toString()} key={index}>
            <Accordion.Header>{faq.question}</Accordion.Header>
            <Accordion.Body>{faq.answer}</Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </Container>
  );
};

export default FAQ;
